const items = {

    PRE_SEASON_ENGINE: 'pre-season-engine',
    PRE_SEASON_GEARBOX: 'pre-season-gearbox',
    PRE_SEASON_WHEELS: 'pre-season-wheels',

    PRE_SEASON_PERF_TOT_EX: 'pre-season-perfTotEx',


    PRE_RACE_WHEELS: 'pre-race-wheels',
    PRE_RACE_DRIVING: 'pre-race-driving',
    PRE_RACE_PITSTOPS: 'pre-race-pitstops',

    PRE_RACE_DRIVING_AGGRESIVE: 'AGGRESSIVE',
    PRE_RACE_DRIVING_AGGRESIVE_THRESHOLD: 'driving-aggressive',

    POST_RACE_ENGINE: 'post-race-engine',
    POST_RACE_GEARBOX: 'post-race-gearbox',
    POST_RACE_WHEELS: 'post-race-wheels',

}

export default items



// WEBPACK FOOTER //
// src/utils/constants/items.js